module.exports = __webpack_public_path__ + "roadmap-3-2a9a684dd6c0849dd1dc518ac3817bf8.webp";